module.exports = __webpack_public_path__ + "static/img/7.414dfa4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/sp/7.png
// module id = h9Ps
// module chunks = 0